/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CrmSendEmailForm_AvailableTemplateFragment = { __typename: 'OrganisationEmailTemplate', id: string, description: string, subject: string, content: string, attachments: Array<{ __typename: 'Attachment', id: string, url: string, title: string, mimeType: string, group: string }> };

export type ApplyEmailContentReplacementsQueryVariables = Types.Exact<{
  subject: Types.Scalars['String']['input'];
  content: Types.Scalars['String']['input'];
  crmCompanyId: Types.Scalars['ID']['input'];
  crmPersonId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  context?: Types.InputMaybe<Types.SendCrmEmailContextInput>;
}>;


export type ApplyEmailContentReplacementsQuery = { applyEmailContentReplacements: { __typename: 'ApplyEmailContentReplacementsResult', subject: string, content: string } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type RequestCrmEmailAttachmentUploadUrlMutationVariables = Types.Exact<{
  input: Types.RequestCrmEmailAttachmentUploadUrlInput;
}>;


export type RequestCrmEmailAttachmentUploadUrlMutation = { requestCrmEmailAttachmentUploadUrl: { __typename: 'RequestUploadUrlResult', uploadUrl: string } };

export type CrmSendEmailMutationVariables = Types.Exact<{
  input: Types.SendCrmEmailInput;
}>;


export type CrmSendEmailMutation = { sendCrmEmail: boolean };

export type UseCrmSendEmailQueryVariables = Types.Exact<{
  emailTemplateContext?: Types.InputMaybe<Types.EmailTemplateContext>;
}>;


export type UseCrmSendEmailQuery = { organisationEmailTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationEmailTemplatesResult', emailTemplates: Array<{ __typename: 'OrganisationEmailTemplate', id: string, description: string, subject: string, content: string, attachments: Array<{ __typename: 'Attachment', id: string, url: string, title: string, mimeType: string, group: string }> }> } };

export const CrmSendEmailForm_AvailableTemplateFragmentDoc = gql`
    fragment CrmSendEmailForm_AvailableTemplate on OrganisationEmailTemplate {
  id
  description
  subject
  content
  attachments {
    id
    url
    title
    mimeType
    group
  }
}
    `;
export const ApplyEmailContentReplacementsDocument = gql`
    query ApplyEmailContentReplacements($subject: String!, $content: String!, $crmCompanyId: ID!, $crmPersonId: ID, $context: SendCrmEmailContextInput) {
  applyEmailContentReplacements(
    subject: $subject
    content: $content
    crmCompanyId: $crmCompanyId
    crmPersonId: $crmPersonId
    context: $context
  ) {
    ... on ApplyEmailContentReplacementsResult {
      subject
      content
    }
  }
}
    `;

/**
 * __useApplyEmailContentReplacementsQuery__
 *
 * To run a query within a React component, call `useApplyEmailContentReplacementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyEmailContentReplacementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyEmailContentReplacementsQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      content: // value for 'content'
 *      crmCompanyId: // value for 'crmCompanyId'
 *      crmPersonId: // value for 'crmPersonId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useApplyEmailContentReplacementsQuery(baseOptions: Apollo.QueryHookOptions<ApplyEmailContentReplacementsQuery, ApplyEmailContentReplacementsQueryVariables> & ({ variables: ApplyEmailContentReplacementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplyEmailContentReplacementsQuery, ApplyEmailContentReplacementsQueryVariables>(ApplyEmailContentReplacementsDocument, options);
      }
export function useApplyEmailContentReplacementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplyEmailContentReplacementsQuery, ApplyEmailContentReplacementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplyEmailContentReplacementsQuery, ApplyEmailContentReplacementsQueryVariables>(ApplyEmailContentReplacementsDocument, options);
        }
export function useApplyEmailContentReplacementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplyEmailContentReplacementsQuery, ApplyEmailContentReplacementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplyEmailContentReplacementsQuery, ApplyEmailContentReplacementsQueryVariables>(ApplyEmailContentReplacementsDocument, options);
        }
export type ApplyEmailContentReplacementsQueryHookResult = ReturnType<typeof useApplyEmailContentReplacementsQuery>;
export type ApplyEmailContentReplacementsLazyQueryHookResult = ReturnType<typeof useApplyEmailContentReplacementsLazyQuery>;
export type ApplyEmailContentReplacementsSuspenseQueryHookResult = ReturnType<typeof useApplyEmailContentReplacementsSuspenseQuery>;
export type ApplyEmailContentReplacementsQueryResult = Apollo.QueryResult<ApplyEmailContentReplacementsQuery, ApplyEmailContentReplacementsQueryVariables>;
export const RequestCrmEmailAttachmentUploadUrlDocument = gql`
    mutation RequestCrmEmailAttachmentUploadUrl($input: RequestCrmEmailAttachmentUploadUrlInput!) {
  requestCrmEmailAttachmentUploadUrl(input: $input) {
    uploadUrl
  }
}
    `;
export type RequestCrmEmailAttachmentUploadUrlMutationFn = Apollo.MutationFunction<RequestCrmEmailAttachmentUploadUrlMutation, RequestCrmEmailAttachmentUploadUrlMutationVariables>;

/**
 * __useRequestCrmEmailAttachmentUploadUrlMutation__
 *
 * To run a mutation, you first call `useRequestCrmEmailAttachmentUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCrmEmailAttachmentUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCrmEmailAttachmentUploadUrlMutation, { data, loading, error }] = useRequestCrmEmailAttachmentUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestCrmEmailAttachmentUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<RequestCrmEmailAttachmentUploadUrlMutation, RequestCrmEmailAttachmentUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCrmEmailAttachmentUploadUrlMutation, RequestCrmEmailAttachmentUploadUrlMutationVariables>(RequestCrmEmailAttachmentUploadUrlDocument, options);
      }
export type RequestCrmEmailAttachmentUploadUrlMutationHookResult = ReturnType<typeof useRequestCrmEmailAttachmentUploadUrlMutation>;
export type RequestCrmEmailAttachmentUploadUrlMutationResult = Apollo.MutationResult<RequestCrmEmailAttachmentUploadUrlMutation>;
export type RequestCrmEmailAttachmentUploadUrlMutationOptions = Apollo.BaseMutationOptions<RequestCrmEmailAttachmentUploadUrlMutation, RequestCrmEmailAttachmentUploadUrlMutationVariables>;
export const CrmSendEmailDocument = gql`
    mutation CrmSendEmail($input: SendCrmEmailInput!) {
  sendCrmEmail(input: $input)
}
    `;
export type CrmSendEmailMutationFn = Apollo.MutationFunction<CrmSendEmailMutation, CrmSendEmailMutationVariables>;

/**
 * __useCrmSendEmailMutation__
 *
 * To run a mutation, you first call `useCrmSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrmSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crmSendEmailMutation, { data, loading, error }] = useCrmSendEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCrmSendEmailMutation(baseOptions?: Apollo.MutationHookOptions<CrmSendEmailMutation, CrmSendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CrmSendEmailMutation, CrmSendEmailMutationVariables>(CrmSendEmailDocument, options);
      }
export type CrmSendEmailMutationHookResult = ReturnType<typeof useCrmSendEmailMutation>;
export type CrmSendEmailMutationResult = Apollo.MutationResult<CrmSendEmailMutation>;
export type CrmSendEmailMutationOptions = Apollo.BaseMutationOptions<CrmSendEmailMutation, CrmSendEmailMutationVariables>;
export const UseCrmSendEmailDocument = gql`
    query UseCrmSendEmail($emailTemplateContext: EmailTemplateContext) {
  organisationEmailTemplates(forContext: $emailTemplateContext) {
    ... on OrganisationEmailTemplatesResult {
      emailTemplates {
        ...CrmSendEmailForm_AvailableTemplate
      }
    }
  }
}
    ${CrmSendEmailForm_AvailableTemplateFragmentDoc}`;

/**
 * __useUseCrmSendEmailQuery__
 *
 * To run a query within a React component, call `useUseCrmSendEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseCrmSendEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseCrmSendEmailQuery({
 *   variables: {
 *      emailTemplateContext: // value for 'emailTemplateContext'
 *   },
 * });
 */
export function useUseCrmSendEmailQuery(baseOptions?: Apollo.QueryHookOptions<UseCrmSendEmailQuery, UseCrmSendEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseCrmSendEmailQuery, UseCrmSendEmailQueryVariables>(UseCrmSendEmailDocument, options);
      }
export function useUseCrmSendEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseCrmSendEmailQuery, UseCrmSendEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseCrmSendEmailQuery, UseCrmSendEmailQueryVariables>(UseCrmSendEmailDocument, options);
        }
export function useUseCrmSendEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseCrmSendEmailQuery, UseCrmSendEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseCrmSendEmailQuery, UseCrmSendEmailQueryVariables>(UseCrmSendEmailDocument, options);
        }
export type UseCrmSendEmailQueryHookResult = ReturnType<typeof useUseCrmSendEmailQuery>;
export type UseCrmSendEmailLazyQueryHookResult = ReturnType<typeof useUseCrmSendEmailLazyQuery>;
export type UseCrmSendEmailSuspenseQueryHookResult = ReturnType<typeof useUseCrmSendEmailSuspenseQuery>;
export type UseCrmSendEmailQueryResult = Apollo.QueryResult<UseCrmSendEmailQuery, UseCrmSendEmailQueryVariables>;